import type { Dispatch, SetStateAction } from 'react';

import { VERIFICATION_STATE_TYPE, VerificationStateType } from '../../../constants';

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../../../../hooks/useAppDispatch';
import { Endpoints } from '@xver/apis';

import { notifications } from '@mantine/notifications';
import { IconHandStop } from '@tabler/icons-react';

interface useRequestResetPasswordProps {
    setVerificationState: Dispatch<SetStateAction<VerificationStateType>>;
    setRequestUserId: Dispatch<SetStateAction<number | undefined>>;
}

export function useRequestResetPassword({
    setVerificationState,
    setRequestUserId,
}: useRequestResetPasswordProps) {
    const dispatch = useAppDispatch();
    const { t } = useTranslation('notifications');

    const {
        formState: { isSubmitting, errors },
        handleSubmit,
        setValue,
        register,
        watch,
    } = useForm({
        defaultValues: {
            email: '',
        },
    });

    const onSubmit = handleSubmit(async (values) => {
        try {
            const response = await Endpoints.v1.Authentication.requestResetPassword(values);
            if (response.data) {
                setRequestUserId(response.data.userID);
                setVerificationState(VERIFICATION_STATE_TYPE.VERIFY);
                return;
            }
        } catch ({ message }: any) {
            notifications.show({
                title: t('auth.resetRequestFailed'),
                message: message || t('auth.resetRequestFailedMessage'),
                icon: <IconHandStop size={32} color={'#eb5757'} />,
            });
            return;
        }
    });

    return {
        isSubmitting,
        errors,
        onSubmit,
        register,
        setValue,
        watch,
    };
}
